// removed by extract-text-webpack-plugin
module.exports = {"star":"_1YiJS","starOutline":"U-1lg _1YiJS","clicked":"_1TvMy","clickable":"PC1Dv","flag":"og6pB","flagged":"_1jXTf","white":"_3uxLD","info":"_2R17G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Stars.css
// module id = 809
// module chunks = 0